import BaseAppBar from "@/components/base/app-bar"
import { DrawerBloc } from "@/components/widget/drawer-bloc"
import { EditContainerProps } from "@/types/page"
import { Box } from "@mui/material"
import useStyles from "./styles"

const EditStandardScheduleContainer = ({ children, onClose, open }: EditContainerProps) => {
    const { classes } = useStyles()

    return (
        <DrawerBloc
            disableScrollLock
            hideBackdrop
            anchor={"right"}
            open={open}
            onClose={onClose}
            transitionDuration={600}
            disableEscapeKeyDown
            classPaper={classes.container}
            data-testid="drawer-bloc"
        >
            <BaseAppBar />
            <Box className="children-wrapper">{children}</Box>
        </DrawerBloc>
    )
}

export default EditStandardScheduleContainer
